const administratorRoleOnly = ["administrator"];
const administratorRoles = ["administrator", "clientadministrator"];
const marketingAdministratorRoles = [
  "administrator",
  "clientadministrator",
  "marketingadministrator",
];
const allNonReadOnlyRoles = [
  "administrator",
  "clientadministrator",
  "marketingadministrator",
];
const allRoles = [
  "administrator",
  "clientadministrator",
  "marketingadministrator",
  "readonly",
];

const getPageAllowedRoles = (page) => {
  switch (page) {
    case "quick-start":
    case "entity-audits":
    case "sitemap":
    case "warehouse-settings":
      return administratorRoleOnly;
    case "blacklist":
    case "communication-settings":
    case "data-import":
    case "automation":
    case "automation-dashboard":
    case "settings":
    case "warehouse-application":
    case "warehouse-applications":
    case "journey-planner":
    case "dwcompetition":
    case "dwcompetitionstage":
    case "dwdatamodel":
    case "dweventprofile":
    case "dwfixture":
    case "dwfixturegrade":
    case "dwhomestatus":
    case "dwopponent":
    case "dwopponenttype":
    case "dwseason":
    case "dwseasonalperiod":
    case "dwteam":
    case "dwtickethospitalityproduct":
    case "dwtype":
      return administratorRoles;
    case "abtest":
    case "campaign":
    case "search":
    case "communication":
    case "communication-audience":
    case "marketing-list":
    case "subscription-group":
      return marketingAdministratorRoles;
    case "account":
    case "communication-activity":
    case "communication-audit":
    case "contact":
    case "page":
    case "report":
      return allRoles;
    default:
      return [];
  }
};

const userHasCorrectRole = (user, allowedRoles) => {
  if (user) {
    return user.userRoles.some(
      (r) => allowedRoles && allowedRoles.includes(r)
    );
  }
  return false;
};

function checkForValidRoles(allowedRoles, globalState) {
  return (
    !allowedRoles ||
    (globalState &&
      globalState.user &&
      globalState.user.userRoles &&
      globalState.user.userRoles.length > 0 &&
      allowedRoles.some((role) => {
        return globalState.user.userRoles.includes(role);
      }))
  );
}

export {
  checkForValidRoles,
  administratorRoleOnly,
  administratorRoles,
  marketingAdministratorRoles,
  allNonReadOnlyRoles,
  allRoles,
  getPageAllowedRoles,
  userHasCorrectRole,
};
